import { EmailIcon } from '@chakra-ui/icons'
import { Box, Flex, Grid, HStack, Link, Stack, StackProps, Text, useBreakpointValue } from '@chakra-ui/react'
import WhatsappButton from 'components/buttons/WhatsappButton'
import SectionStack from 'components/common/SectionStack'
import ExternalLink from 'components/links/ExternalLink'
import SafetySection from 'components/sections/SafetySection'
import { FacebookIcon } from 'components/svg/FacebookIcon'
import { InstagramIcon } from 'components/svg/InstagramIcon'
import IshaLogoSalmon from 'components/svg/IshaLogoSalmon'
import { LinkedInIcon } from 'components/svg/LinkedInIcon'
import { YouTubeIcon } from 'components/svg/YouTubeIcon'
import { Body1, Body2 } from 'components/typography'
import { FC } from 'react'

import CompanyInfoSectionIsha from './components/CompanyInfoSectionIsha'

const IshaFooter: FC = () => {
  const isMd = useBreakpointValue({ base: false, md: true })

  return (
    <Stack bg="darkchoc" color="ishafit.20">
      <Stack maxW={1280} m="0 auto" pt={4} pb={24}>
        {isMd ? (
          <Grid templateColumns="1fr 1fr 1fr">
            <SectionStack>
              <IshaLogoSalmon />
            </SectionStack>

            <IshaSocialLinksSection fill="ishafit.30" />
            <IshaContactSection />
            <IshaLinksSection />
          </Grid>
        ) : (
          <>
            <SectionStack>
              <IshaLogoSalmon />
            </SectionStack>
            <IshaSocialLinksSection fill="ishafit.30" />
            <IshaContactSection />
            <IshaLinksSection />
          </>
        )}
        <CompanyInfoSectionIsha />

        <SafetySection showTitle />
      </Stack>
    </Stack>
  )
}

export default IshaFooter

export const ISHA_WHATSAPP_LINK = `https://wa.me/5511945490473`
export const ISHA_WHATSAPP_NUMBER_MASKED = '(11) 94549-0473'
export const ISHA_SUPPORT_EMAIL = 'contato@souisha.com.br'

export const IshaContactSection: FC<StackProps> = (props) => {
  return (
    <SectionStack {...props}>
      <Text textStyle={{ base: 'body1sm', lg: 'body1' }} pb="4px" borderBottom="2px solid #25241E">
        Contato
      </Text>
      <Text textStyle={{ base: 'h5sm', lg: 'h5' }}>Quer uma ajuda mais rápida? Fale com a gente pelo WhatsApp.</Text>
      <WhatsappButton
        mt="8px"
        bg="ishafit.30"
        textColor="ishafit.70"
        iconColor="ishafit.70"
        hover="ishafit.35"
        whatsappLink={ISHA_WHATSAPP_LINK}
        withLabel
      />
      <ExternalLink
        href={`mailto:${ISHA_SUPPORT_EMAIL}`}
        color="alabaster"
        _hover={{ textColor: 'grayscale.30' }}
        textDecor="none"
        fontWeight="500"
      >
        <HStack>
          <EmailIcon boxSize={5} />
          <Text color="alabaster" _hover={{ textColor: 'grayscale.30' }}>
            {ISHA_SUPPORT_EMAIL}
          </Text>
        </HStack>
      </ExternalLink>
    </SectionStack>
  )
}
export const SOCIAL_LINKS_ISHA = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/isha.br/',
    icon: InstagramIcon
  },
  {
    label: 'Linkedin',
    href: 'https://www.linkedin.com/company/souisha/',
    icon: LinkedInIcon
  },
  {
    label: 'Youtube',
    href: 'https://www.youtube.com/@souisha',
    icon: YouTubeIcon
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61570836328645',
    icon: FacebookIcon
  }
]
interface SocialLinksSectionProps {
  fill?: string
}
export const IshaSocialLinksSection: FC<SocialLinksSectionProps> = ({ fill }) => {
  return (
    <SectionStack>
      <Text textStyle={{ base: 'body1sm', lg: 'body1' }} pb="4px" borderBottom="2px solid #25241E">
        Siga nas redes
      </Text>
      <Flex wrap="wrap" sx={{ gap: '2rem' }}>
        {SOCIAL_LINKS_ISHA.map(({ label, href, icon }) => (
          <Body1 key={label} display="flex" alignItems="center" sx={{ gap: '.5rem' }}>
            <ExternalLink href={href}>
              <Box as={icon} fill={fill || 'dandelion'} />
            </ExternalLink>
          </Body1>
        ))}
      </Flex>
    </SectionStack>
  )
}
const PAGES = [
  { label: 'Termos e condições', href: '/termos-e-condicoes' },
  { label: 'Política de privacidade', href: '/politica-de-privacidade' }
]
const IshaLinksSection: FC = () => {
  return (
    <SectionStack flex={1}>
      <Body1 color="alabaster" pb="4px" borderBottom="2px solid #25241E">
        Páginas
      </Body1>
      <Grid gridTemplateColumns="repeat(1, 1fr)">
        {PAGES.map(({ label, href }) => (
          <Body2 py="0.5rem" color="ishafit.30" key={label}>
            <Link {...{ href }}>{label}</Link>
          </Body2>
        ))}
      </Grid>
    </SectionStack>
  )
}
